import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { completeLogin } from '../auth/oidc'

/**
 * OIDC redirect target (`/auth/callback`). Exchanges the authorization code for
 * tokens (PKCE), stores the access token, then navigates to where the user was
 * headed. The authorization code is single-use, so the once-guard prevents the
 * StrictMode double-invoke from replaying the exchange and failing it.
 */
export function AuthCallback() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [failed, setFailed] = useState(false)
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    completeLogin()
      .then((returnTo) => navigate(returnTo, { replace: true }))
      .catch(() => setFailed(true))
  }, [navigate])

  return (
    <p className="p-8 text-neutral-500">
      {failed ? t('auth.callbackError') : t('auth.completing')}
    </p>
  )
}
